define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        EasingTypes  = require("shared/ui/experience/widgets/animations/EasingTypes"),
        template     = require("ui/experience/widgets/animations/slideOut/SlideOutAnimationPropertiesView.tpl");

    /**
     * The properties view for a slide animation.
     *
     * @class SlideOutAnimationPropertiesView
     * @constructor
     *
     * @cfg {SlideOutAnimationModel} model The slide animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#slideOutEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#direction": "direction",
            "#delay": {
                observe: "delay",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/animations/slideOut/SlideOutAnimationPropertiesView.js